import {
  Link,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  redirect,
  useFetcher,
  useLoaderData,
  useRouteError,
} from "@remix-run/react";
import "./tailwind.css";
import { ActionFunctionArgs, LoaderFunctionArgs } from "@remix-run/node";
import { login_cookie } from "./cookies.server";
import Header from "./components/header";
import { convertStringToBoolean } from "./components/utilis";
import { useEffect, useState } from "react";
import useOnlineStatus from "./components/useOnlineStatus";

export async function loader({ request }: LoaderFunctionArgs) {
  const cookieHeader = request.headers.get('Cookie');
  const cookie = await login_cookie.parse(cookieHeader);
  const userId = cookie?.userId ? cookie.userId : "";
  const { APP_ENV } = process.env
  let apiUrl

  if (APP_ENV === "staging") {
    apiUrl = "https://stage-api.aaonxt.com";
  } else {
    apiUrl = "https://aao-api.ibee.ai";
  }

  try {
    const creatorProfileImage = await fetch(`${apiUrl}/creators/${userId}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${cookie?.accessToken}`
      }
    });

    const profileImageResponse = await creatorProfileImage.json();

    return {
      isAdmin: cookie?.isAdmin,
      userProfile: profileImageResponse
    }
  } catch (error) {

    return error
  }

}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.clone().formData();
  const formDataValues = Object.fromEntries(formData);

  if (formDataValues.action === "expiryCookie") {
    const date = new Date();
    const expiryDate = date;

    return redirect("/login", {
      headers: {
        'Set-Cookie': await login_cookie.serialize(login_cookie, {
          expires: expiryDate,
        }),
      },
    })
  }

  return null
}

export default function App() {
  const loaderData = useLoaderData();
  const fetcher = useFetcher();
  const [userProfileImage, setUserProfileImage] = useState(null);

  const expireCookie = () => {
    fetcher.submit(
      {
        action: "expiryCookie"
      },
      {
        method: 'POST',
      }
    );
  }

  useEffect(() => {
    if (loaderData?.userProfile?.creator?.creatorImage) {
      setUserProfileImage(loaderData?.userProfile?.creator?.creatorImage);
    }
  }, [])

  useEffect(() => {
    if (loaderData?.userProfile?.creator?.creatorImage) {
      setUserProfileImage(loaderData?.userProfile?.creator?.creatorImage);
    }
  }, [loaderData])

  return (
    <>
      <Header expireCookie={expireCookie} isAdmin={convertStringToBoolean(loaderData?.isAdmin)} userProfileImage={userProfileImage} />
      <Outlet />
    </>
  )
}

export function ErrorBoundary() {
  const error = useRouteError();
  const isOnline = useOnlineStatus();

  if (!isOnline) {
    return (
      <html>
        <head>
          <title>Error page</title>
        </head>
        <body>
          <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", fontFamily: "Open Sans, sans-serif", backgroundColor: "#F1EFFF" }}>
            <div style={{ fontSize: "24px", marginBottom: "8px", fontWeight: "normal", color: "#5D09C7" }}>
              You are offline.
            </div>
            <div style={{ fontSize: "20px", color: "#808091", marginBottom: "8px", maxWidth: "60%", lineHeight: 1.8 }}>
              Please check your internet connection.
            </div>
            <div style={{ width: "100%", textAlign: "center", marginTop: "20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <button style={{ width: "250px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "transparent", border: "1px solid #ccc", borderRadius: "3px", cursor: "pointer", fontSize: "15px" }} onClick={() => window.location.reload()}>Click here to Refresh the page</button>
            </div>
          </div>
        </body>
      </html>
    );
  }

  if (error?.status === 404) {
    return (
      <html>
        <head>
          <title>Error page</title>
        </head>
        <body>
          <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", fontFamily: "Open Sans, sans-serif", backgroundColor: "#F1EFFF" }}>
            <div style={{ fontSize: "24px", marginBottom: "8px", fontWeight: "normal", color: "#5D09C7" }}>
              404. Page Not Found.
            </div>
            <div style={{ fontSize: "18px", color: "#808091", marginBottom: "8px", maxWidth: "60%", lineHeight: 1.8 }}>
              The page you are looking for might have been removed, <br />had its name changed, or is temporarily unavailable.
            </div>
            <div style={{ fontSize: "16px", paddingTop: "10px", color: "#666", marginBottom: "16px", marginTop: "6px" }}>
              <Link to="/" style={{ width: "200px", height: "34px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "transparent", border: "1px solid #ccc", borderRadius: "3px", cursor: "pointer", textDecoration: "none", color: "#666" }}>
                Go to Dashboard
              </Link>
            </div>
          </div>
        </body>
      </html>
    );
  } else {

    return (
      <html>
        <head>
          <title>Error page</title>
        </head>
        <body>
          <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", fontFamily: "Open Sans, sans-serif", backgroundColor: "#F1EFFF" }}>
            <div style={{ fontSize: "24px", marginBottom: "8px", fontWeight: "normal", color: "#5D09C7" }}>
              Problem detected, working on a fix.
            </div>
            <div style={{ fontSize: "20px", color: "#808091", marginBottom: "8px", maxWidth: "60%", lineHeight: 1.8 }}>
              Thanks for patience!
            </div>
            <div style={{ fontSize: "16px", color: "#666", marginBottom: "16px", marginTop: "6px" }}>
              <button style={{ width: "200px", height: "34px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "transparent", border: "1px solid #ccc", borderRadius: "3px", cursor: "pointer" }} onClick={() => window.location.reload()}>Click here to Refresh the page</button>
            </div>
          </div>
        </body>
      </html>
    );
  }
}
